'use client';

import { c as _c } from "react/compiler-runtime";
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { UnauthQueryOptions } from '@/api';
import { SearchSideAdBanner } from '@/app/_components/ads';
import { DesktopPageShell } from '@/components/template/DesktopPageShell';
import { PAGE_SIZE } from '../../constants';
import { buildPaginationMeta } from '../../utils';
import { SearchContentsCardSkeletonList } from '../SearchContentsCardSkeleton';
import { SearchSectionShell } from '../SearchSectionShell';
import { PolicyInfoFilter } from './PolicyInfoFilter';
import { PolicyInfoList } from './PolicyInfoList';
interface PolicyInfoSearchProps {
  keyword: string;
  page: number;
  onPageChange: (page: number) => void;
  isFilterOpen: boolean;
  onCloseFilter: () => void;
  provisionCodes: string[];
  onToggleProvision: (code: string) => void;
  onReset: () => void;
}
export function PolicyInfoSearch(t0) {
  const $ = _c(26);
  const {
    keyword,
    page,
    onPageChange,
    isFilterOpen,
    onCloseFilter,
    provisionCodes,
    onToggleProvision,
    onReset
  } = t0;
  let t1;
  if ($[0] !== keyword || $[1] !== page || $[2] !== provisionCodes) {
    t1 = UnauthQueryOptions["get:/wello/v2/allows/query/best-contents"]({
      query: {
        searchKeyword: keyword,
        provisionCodeList: provisionCodes.length > 0 ? provisionCodes : undefined,
        bestContentsSort: "LATEST",
        page,
        size: PAGE_SIZE
      }
    });
    $[0] = keyword;
    $[1] = page;
    $[2] = provisionCodes;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = {
      ...t1,
      placeholderData: keepPreviousData
    };
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    data,
    isLoading
  } = useQuery(t2);
  const t3 = data?.context?.totalCount ?? 0;
  let t4;
  if ($[6] !== t3) {
    t4 = buildPaginationMeta(t3);
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const meta = t4;
  let t5;
  if ($[8] !== isFilterOpen || $[9] !== onCloseFilter || $[10] !== onReset || $[11] !== onToggleProvision || $[12] !== provisionCodes) {
    t5 = <PolicyInfoFilter isDrawerOpen={isFilterOpen} onCloseDrawer={onCloseFilter} onApplyDrawer={onCloseFilter} provisionCodes={provisionCodes} onToggleProvision={onToggleProvision} onReset={onReset} />;
    $[8] = isFilterOpen;
    $[9] = onCloseFilter;
    $[10] = onReset;
    $[11] = onToggleProvision;
    $[12] = provisionCodes;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <SearchSideAdBanner />;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== data?.context?.contents || $[16] !== isLoading) {
    t7 = isLoading ? <SearchContentsCardSkeletonList count={PAGE_SIZE} /> : <PolicyInfoList items={data?.context?.contents ?? []} />;
    $[15] = data?.context?.contents;
    $[16] = isLoading;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== meta || $[19] !== onPageChange || $[20] !== page || $[21] !== t7) {
    t8 = <SearchSectionShell meta={meta} page={page} pageSize={PAGE_SIZE} onPageChange={onPageChange}>{t7}</SearchSectionShell>;
    $[18] = meta;
    $[19] = onPageChange;
    $[20] = page;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== t5 || $[24] !== t8) {
    t9 = <DesktopPageShell className="mt-20 w-full mobile-tablet:mt-0" leftAside={t5} rightAside={t6}>{t8}</DesktopPageShell>;
    $[23] = t5;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
}